<template>
    <el-dialog
    title="数字人"
    width="100rem"
    :visible.sync="dialogVisible">
    <video autoplay controls style="width: 100%;max-height:70rem;" :src="videoUrl"></video>
</el-dialog>
</template>

<script>
    export default {
        data(){
            return {
               videoUrl:'',
               dialogVisible:false,
            }
        },
        computed:{
        },
        methods:{
        }
    }
</script>

<style lang="less" scoped>
@import "../../../assets/css/globalCard.less";
@import "../../../assets/css/aiCommon.less";
/deep/.el-dialog__body {
    padding-top: 0 !important;
}

/deep/.el-dialog {
    border-radius: 2rem;
}
</style>